import { useDispatch } from 'react-redux';
import { GetDocumentsReferenceInputDto, GetDocumentsReferenceOutputDto } from '@api/izibizi-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchBankInsuranceDocumentReference = (): UseFetchHookOutput<
	Omit<GetDocumentsReferenceInputDto, 'metadata'>,
	GetDocumentsReferenceOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<GetDocumentsReferenceInputDto, GetDocumentsReferenceOutputDto>({
		operationKey: 'retrieveDocumentsReference',
		onSuccess: (res) => {
			if (res) {
				dispatch(saveSuccessServiceResponse({ retrieveBankInsuranceDocumentReference: res.data }));
			}
		},
	});
};
